<template lang="pug">
section.orders
  .table-responsive(v-if="$router.user.roleScore >= 2")
    table.table.table-striped.table-bordered.table-hover
      thead
        tr
          th Order ID
          th SKU
          th Name
          th Quantity
          th Category
          th Reason
          th Notes
      template(v-if="!loadingData && orders_count > 0")
        template(v-for="order in orders")
          SingleProductionOrderNC(v-if="order.nc_products.length || order.nc_components.length" :key="order.id_number" :order="order")
      span(v-else)
        .loading-data(v-if="loadingData")
          span.loading
          h5 Loading orders ...
        .loading-data(v-else)
          h6 No orders found.
        .clearer
    nav(aria-label="Orders navigation" v-if="orders_count > 0 && pages > 1")
      ul.pagination.justify-content-center
        li.page-item(:class="page == 1 ? 'disabled' : ''")
          a.page-link(@click.prevent="navigateToPage(page - 1)" href="#" aria-label="Previous")
            span(aria-hidden="true") &laquo;
            span.sr-only Previous
        li.page-item(:class="page == 1 ? 'disabled' : ''")
          a.page-link(@click.prevent="navigateToPage(1)" href="#") First
        li.page-item(v-for="page_number in pages" :key="page_number" :class="page_number == page ? 'active' : ''")
          a.page-link(v-if="!(page_number <= page - 10 || page_number >= page + 10)" href="#" @click.prevent="navigateToPage(page_number)") {{ page_number }}
        li.page-item(:class="page == pages ? 'disabled' : ''")
          a.page-link(@click.prevent="navigateToPage(pages)" href="#") Last
        li.page-item(:class="page == pages ? 'disabled' : ''")
          a.page-link(@click.prevent="navigateToPage(page + 1)" href="#" aria-label="Next")
            span(aria-hidden="true") &raquo;
            span.sr-only Next
  div(v-else) Access denied! You can't access this page.
</template>

<script>
import ProductionService from "@/services/ProductionService";
import SingleProductionOrderNC from "./SingleProductionOrderNC";
export default {
  name: "ProductionOrdersNC",
  data() {
    return {
      page: 1,
      pages: 0,
      orders: "",
      order_list: "",
      orders_count: "",
      total: 0,
      loadingData: false,
      pageSize: 50,
      filters: {
        nc: true
      }
    };
  },
  components: {
    SingleProductionOrderNC
  },
  mounted() {
    this.page = 1;
    this.getFilteredProductionOrders(this.page)
  },
  methods: {
    async getFilteredProductionOrders(page) {
      this.loadingData = true;
      
      // Ensure page is within valid range
      if (page <= 1) {
        this.page = 1;
      } else if (page > this.pages && this.pages > 0) {
        this.page = this.pages;
      } else {
        this.page = page;
      }
      
      try {
        const response = await ProductionService.getFilteredProductionOrders(
          this.filters,
          this.page - 1, // Backend uses 0-based indexing
          this.pageSize
        );
        
        // Handle new response format with pagination
        if (response.data.models) {
          this.order_list = response.data.models;
          this.orders = this.order_list;
          this.orders_count = this.order_list.length;
          this.pages = response.data.pages;
          this.total = response.data.total;
        } else {
          // Fallback for old response format (backward compatibility)
          this.order_list = response.data;
          this.orders = this.order_list;
          this.orders_count = this.order_list.length;
          this.pages = 1;
          this.total = this.order_list.length;
        }
      } catch (error) {
        console.error("Error fetching production orders:", error);
        this.orders = [];
        this.orders_count = 0;
        this.pages = 0;
        this.total = 0;
      }
      
      this.loadingData = false;
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    navigateToPage(page) {
      if (page >= 1 && page <= this.pages) {
        this.getFilteredProductionOrders(page);
      }
    }
  }
}
</script>